import React, {useState, useEffect, useRef} from 'react'
import styled, {createGlobalStyle} from 'styled-components'
import {getCookie} from '../../libs/cookie'
import moment from 'moment'
import {saveAs} from 'file-saver'
import html2canvas from 'html2canvas'
import {InventoryIcon} from "../../common/icons"
import {itemAPI2} from '../../libs/api2'
import {numberFormat} from "../../libs/util"


const EstimateCapture = (props) => {
    const [estimateItem, setEstimateItem] = useState(null)
    const [TotalPrice, setTotalPrice] = useState(null)
    const [itemLoading, setItemLoading] = useState(false)
    const [ad, setAd] = useState(null)
    const [mallInfo, setMallInfo] = useState(null)
    const date = new Date()
    const view = useRef(null)
    const [id, setId]=useState(0)//견적번호

    useEffect(() => {
        setEstimateItems()
    }, []) // eslint-disable-line

    const setEstimateItems = () => {
        setItemLoading(true)
        const estimateItems = getCookie('item_est')
        if (!estimateItems) {
            setItemLoading(false)
            setTimeout(() => {
                props.onCaptureHandler()
            }, 1500)
            return
        }

        const type = props.priceType || 'cash'

        itemAPI2.getItemEstimate(type,props.minishopIdx).then((response) => {
            if(response.data.desc==='not_login'){
                window.location.href = process.env.REACT_APP_SSO_URL
            }else{
                if (response.status === 200) {
                    const {ad, mall} = response.data
                    const {items, itemsPrice, id} = response.data.estimate

                    setItemLoading(false)
                    if (items) {
                        setAd(ad)
                        setEstimateItem(items)
                        setTotalPrice(itemsPrice)
                        setMallInfo(mall)
                        setId(id)
                        setTimeout(() => {
                            imgSave()
                        }, 500)
                    }
                }
            }
        })
    }

    const imgSave = () => {
        html2canvas(view.current, { useCORS: true }).then((canvas) => {
            canvas.toDataURL("image/jpeg", 1.0)
            canvas.toBlob(function (blob) {
                saveAs(blob, `행복쇼핑_견적_${moment(date).format('YYMMDD_HHmmss')}.jpg`)
            }, "image/jpeg", 1.0); // JPG 파일로 저장
        }).then(()=> {
            setTimeout(() => {
                props.onCaptureHandler()
            }, 2000)
        })
    }

    return (
        <>
            <GlobalStyle/>
            <EstimateSaveContainer>
                <Style className="estimate-save-wrapper" ref={view}>
                    {!itemLoading ? (
                        estimateItem ? (
                            <>
                                <div className="top">
                                    <div className="logo-field">
                                        {mallInfo?<img src={mallInfo.mallImage} alt={mallInfo.mallWebUser} />:<img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_logo/1/1_180_72.png`} alt="행복쇼핑" />}
                                    </div>
                                    <div className="title-field">
                                        <h2>{mallInfo?'':'국내 최저가 '}PC견적 서비스 <span>{mallInfo?'MINISHOP.PPING.KR/'+mallInfo.mallWebUser:'PC.PPING.KR'}</span></h2>
                                    </div>
                                    <div className="date-field">
                                        <span>{moment(date).format("YYYY.  MM.  DD")}</span>
                                        <span className={'estimate_code'}>(견적번호: {id})</span>
                                    </div>
                                </div>
                                <div className="top-divider"/>
                                <div className="table">
                                    <div className="thead">
                                        <div className="column num">번호</div>
                                        <div className="column cate">분류</div>
                                        <div className="column image">이미지</div>
                                        <div className="column name">상품명</div>
                                        <div className="column min-money">{mallInfo?'판매가':'최저가'}</div>
                                        <div className="column quantity">수량</div>
                                        <div className="column amount">합계</div>
                                    </div>
                                    <div className="tbody">
                                        <div className="inventory-banner">
                                            <InventoryIcon />
                                            <p>
                                                <strong>재고인증</strong>
                                                &nbsp;
                                                <span>상품으로 견적 구성 시 최저가 구매 가능합니다.</span>
                                            </p>
                                        </div>
                                        {estimateItem.map((el, index) => (
                                            <div className="row" key={`${el.itemId}_${index}`}>
                                                <div className="column num">{index+1}</div>
                                                <div className="column cate">{el.categoryName}</div>
                                                <div className="column image">
                                                    <div className={el.hasStock ? 'has-stock' : 'out-of-stock'}>
                                                        <InventoryIcon />
                                                    </div>
                                                    <img
                                                        src={el.itemImage?el.itemImage:''}
                                                        alt={el.itemFullName}
                                                        onError={(e) => {
                                                            e.currentTarget.src = `${process.env.REACT_APP_CDN_IMG}/img_shopping/img_goods/img_no/no_item_img.jpg`;
                                                        }}
                                                    />
                                                </div>
                                                <div className="column name"><span>{el.itemFullName}</span><span>&nbsp;-&nbsp;</span><span className="item-id">{el.itemId}</span></div>
                                                <div className="column min-money" style={{color:typeof el.price==='number'?'#333333':'#999999'}}>{typeof el.price==='number'?numberFormat(el.price):''}</div>{/*최저가*/}
                                                <div className="column quantity">{el.count}</div>
                                                <div className="column amount">
                                                    <span>{typeof el.price==='number'?numberFormat(el.price*el.count):el.price}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="tfoot">
                                        <ul>
                                            <li><span>ㆍ</span><span>행복쇼핑이 100% 안전 거래를 보장합니다.</span></li>
                                            <li><span>ㆍ</span><span>판매가격의 변동에 따라 최저가격과 실제 구매가격이 상이할 수 있습니다.</span></li>
                                        </ul>
                                        <div className="total-price">
                                            <span className="txt">견적 합계</span>
                                            <span className="price">
                                                <strong className="amount">{numberFormat(TotalPrice)}</strong>
                                                <span className="wons">&nbsp;원</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                {
                                    ad&&(
                                        <div className="ad-banner">
                                            <img style={{width:'100%'}} src={ad.image} alt="광고 이미지"/>
                                        </div>
                                    )
                                }
                            </>
                        ) : (
                            <div className="no-item">상품견적에 담긴 상품이 없습니다.</div>
                        )
                    ) : (
                        <div className="loading">
                            <img
                                src="//cdnimg.happyshopping.kr/img_static/img_pres/_v5/happy_loading_5.gif"
                                alt="loading"
                            />
                        </div>
                    )}
                </Style>
            </EstimateSaveContainer>
        </>
    )
}

const GlobalStyle = createGlobalStyle`
    #header, #footer {
        display: none;
    }
`

const EstimateSaveContainer = styled.div`
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    overflow-y: auto;

    font-size:12px;
    font-family:'Noto Sans KR', sans-serif;
    color:#333;
    font-weight:400;
`

const Style = styled.div`
    width: 760px;
    margin: 0 auto;
    div {
        box-sizing: border-box;
    }
    .top {
        width: 100%;
        height: 52px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        .logo-field {
            img {
                width: 90px;
            }
        }
        .title-field {
            margin: 0 auto;
            letter-spacing: -1.2px;
            line-height:24px;
            font-weight:bold;
            h2 { font-size: 16px; }
            span{ color:#418DED; }
        }
        .date-field {
            color: #AAAAAA;
            letter-spacing: -0.66px;
            line-height:17px;
            .estimate_code{
                display:inline-block;
                margin-left:4px;
                color:#333;
                font-weight:bold;
            }
        }
    }

    .top-divider {
        width: calc(100% - 32px);
        margin:0 auto;
        height: 2px;
        background-color: #333;
    }
    .table {
        margin-top: 24px;
        width: 100%;
        padding: 0 16px;
        .thead, .tbody {
            .column {
                display: flex;
                align-items: center;
                text-align: justify;
                flex-wrap: wrap;
            }
            .num { width: 32px; }
            .cate { width: 72px; }
            .image { width: 72px; }
            .name { width: 351px; }
            .min-money { width: 82px; }
            .quantity { width: 30px; }
            .amount { width: 89px; }
        }
        .thead {
            border-top: 1px solid #AAAAAA;
            background-color: #F7F7F7;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            .column {
                height: 38px;
                justify-content: center;
            }
        }
        .tbody {
            .inventory-banner {
                display: flex;
                align-items: center;
                height: 38px;
                padding-left: 108px;
                background-color: #333333;
                i { margin-right: 4px; }
                p {
                    color: #FFFFFF;
                    strong {
                        font-size: 13px;
                        color: #F5AC00;
                    }
                }
            }
            .row {
                display: flex;
                align-items: center;
                justify-content: center;
                border-bottom:1px solid #DCDCDC;
                align-content: center;
                .column {
                    height: 72px;
                    justify-content: center;
                }
                .num {
                    width:32px;
                    font-size:11px;
                    line-height:16px;
                    height: 72px;
                }
                .cate {
                    width:72px;
                    font-weight: bold;
                    line-height: 17px;
                    justify-content: center;
                }
                .image {
                    width:72px;
                    justify-content: center;
                }
                .name {
                    width:351px;
                    line-height: 17px;
                    justify-content: flex-start;
                    padding: 0 8px;
                    align-content:center;
                    &>span:nth-of-type(1){font-weight:bold;}
                    .item-id {
                        color: #418DED;
                    }
                }
                .min-money{
                    width:82px;
                    justify-content: flex-end;
                    padding: 0 8px;
                    letter-spacing: -0.3px;
                    line-height: 18px;
                }
                .quantity {
                    width:30px;
                    justify-content: center;
                    letter-spacing: -0.3px;
                    line-height: 18px;
                }
                .amount {
                    width:89px;
                    justify-content: flex-end;
                    padding: 0 8px;
                    line-height: 18px;
                }
                .image {
                    position: relative;
                    .has-stock {
                        display: block;
                        position: absolute;
                        top: 4px;
                        left: 4px;
                    }
                    .out-of-stock {
                        display: none;
                    }
                    img {
                        width: 64px;
                        height: 64px;
                    }
                }
            }
        }
        .tfoot {
            border-bottom: 1px solid #AAAAAA;
            background-color: #F7F7F7;
            padding: 19px 8px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            ul {
                color: #666666;
                font-size: 12px;
                //letter-spacing: -0.6px;
                line-height: 1.2;
                li {
                    display: flex;
                    &:nth-of-type(n+2) {
                        margin-top: 4px;
                    }
                }
            }
            .total-price {
                display: flex;
                flex-direction: row;
                font-weight: bold;
                align-items: center;
                .txt {
                    color: #666666;
                    font-size: 16px;
                    margin-right: 8px;

                    line-height:24px;
                    letter-spacing: -0.4px;
                }
                .price {
                    display: flex;
                    align-items: baseline;
                    .amount {
                        color: #F34522;
                        font-size: 19px;

                        line-height:27px;
                        letter-spacing: -0.47px;
                    }
                    .wons {
                        color: #666666;
                        font-size: 13px;

                        line-height:19px;
                        letter-spacing: -0.33px;
                    }
                }
            }
        }
    }
    .ad-banner {
        width: 100%;
        padding: 25px 16px;
        text-align: center;
    }
    .no-item {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        height: 160px;
    }
    .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 160px;
        &>img {
            width: 60px;
            height: auto;
        }
    }
`

export default EstimateCapture



// WEBPACK FOOTER //
// ./src/estimate_list/components/layer/EstimateCapture.js